/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Branches_Table_Main_ContactInputs */

const en_branches_table_main_contact = /** @type {(inputs: Branches_Table_Main_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main contact`)
};

const pt_br2_branches_table_main_contact = /** @type {(inputs: Branches_Table_Main_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contato principal`)
};

/**
* | output |
* | --- |
* | "Main contact" |
*
* @param {Branches_Table_Main_ContactInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const branches_table_main_contact = /** @type {((inputs?: Branches_Table_Main_ContactInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Branches_Table_Main_ContactInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_branches_table_main_contact(inputs)
	return pt_br2_branches_table_main_contact(inputs)
});